import React from 'react'

const MapPointEdit = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.16732 8.66647H7.93398L13.0673 3.53314L11.3007 1.76647L6.16732 6.8998V8.66647ZM14.259 1.16647L13.6673 0.574805C13.3423 0.249805 12.8173 0.249805 12.4923 0.574805L11.8923 1.1748L13.659 2.94147L14.259 2.34147C14.584 2.01647 14.584 1.49147 14.259 1.16647ZM11.9173 7.04147C11.9673 7.34147 12.0007 7.65814 12.0007 7.9998C12.0007 9.4248 11.1007 11.8665 7.00065 15.6165C2.90065 11.8748 2.00065 9.4248 2.00065 7.9998C2.00065 4.64147 4.57565 2.83314 7.00065 2.83314C7.26732 2.83314 7.54232 2.85814 7.80898 2.8998L9.18398 1.5248C8.48398 1.2998 7.75065 1.16647 7.00065 1.16647C3.50065 1.16647 0.333984 3.8498 0.333984 7.9998C0.333984 10.7665 2.55898 14.0415 7.00065 17.8331C11.4423 14.0415 13.6673 10.7665 13.6673 7.9998C13.6673 7.15814 13.534 6.38314 13.2923 5.66647L11.9173 7.04147Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
)

export default MapPointEdit
